// import React, { useEffect, useState } from "react";
// import Bannerslide from "../../Component/Home/Bannerslide";
// import "./Profile.css";
// import ServiceAccordion from "./ServiceAccordion";
// import { useDispatch, useSelector } from "react-redux";
// import { NavLink, useNavigate } from "react-router-dom";
// import { checkLogin, logout } from "../../Redux/Slice/authSlice";
// import InnerBanner from "../../Component/InnerBanner";
// import PaymentHistory from "./PaymentHistory";
// import HomeServices from "../../Services/HomeServices";
// import toast from "react-hot-toast";
// const Profile = () => {
//   const { loading, error, token, user } = useSelector((state) => state.auth);
//   const navigate = useNavigate();
//   const [profileTab, setProfileTab] = useState(true);
//   const [serviceTab, setServiceTab] = useState(false);
//   const [paymentTab, setPaymentTab] = useState(false);
//   const [isFinallySubmittedForm, setIsFinallySubmittedForm] = useState(false);
//   const [serviceData, setServiceData] = useState([]);

//   const [modal, setModal] = useState(false);
//   const dispatch = useDispatch();
//   // useEffect(() => {
//   //   if (!token) {
//   //     navigate("/")
//   //   }
//   // }, [])
//   useEffect(() => {
//     dispatch(checkLogin());
//   }, []);
//   console.log("DTG17", user);
//   const handleLogout = (e) => {
//     e.preventDefault();
//     dispatch(logout());
//     toast.success("Logged out Successfully");
//     navigate("/");
//   };

//   const ProfileModal = () => {
//     return (
//       <>
//         <div className="modal_wrapper_main_div"></div>
//         <div className="modal_div_main">
//           <h5>Edit Profile Info</h5>
//           {user?.customerNo && (
//             <div className="edit_input_Wrapper">
//               <label>Customer# {user?.customerNo}</label>
//             </div>
//           )}

//           <div className="edit_input_Wrapper">
//             <label>Name</label>
//             <input type="text" defaultValue={user?.name} />
//           </div>

//           <div className="edit_input_Wrapper mt-2">
//             <label>Email</label>
//             <input type="text" defaultValue={user?.email} />
//           </div>
//           <div className="submit_btn_wrapper">
//             <button onClick={() => setModal(false)}>Submit</button>
//           </div>
//         </div>
//       </>
//     );
//   };

//   const handleClick = () => {
//     const link = document.createElement("a");
//     link.href = "https://g.co/gemini/share/4c979bd45f5b";
//     link.target = "_blank";
//     link.rel = "noopener noreferrer";
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   const fetchApplicantData = async () => {
//     try {
//       const res = await HomeServices.getPrimariApplicantData();
//       console.log("user", res);
//       if (res?.status && res?.data) {
//         setIsFinallySubmittedForm(
//           res?.data[0]?.PrimaryApplicantData?.isFinallySubmittedForm,
//         );
//       } else {
//         toast?.error("server Error!");
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };
//   const fetchServicesData = async () => {
//     try {
//       const res = await HomeServices.getAllAssignedServices();
//       console.log("DFFE12", res.data);
//       // return
//       if (res && res.status) {
//         setServiceData(res.data);
//       } else {
//       }
//     } catch (error) {
//       console.error("Error uploading document:", error);
//     }
//   };

//   useEffect(() => {
//     fetchServicesData();
//     fetchApplicantData();
//   }, []);

//   return (
//     <>
//       {modal && <ProfileModal />}
//       {/* <Bannerslide /> */}
//       {/* <CustomLoader loading={isLoading} /> */}

//       <InnerBanner InBanHead="My Profile" InBanLi="Profile" />

//       <div className="profile_Wrapper">
//         {/* <h3 className='your_profile_head'>Your Profile</h3> */}
//         <div
//           className="profile_sidebar_content_wrapper"
//           style={{
//             display: "flex",
//             justifyContent: "flex-start",
//           }}
//         >
//           <div className="profile_tabs_wrapper">
//             <button
//               className={profileTab ? "profile_active" : "button"}
//               onClick={() => {
//                 setProfileTab(true);
//                 setServiceTab(false);
//                 setPaymentTab(false);
//               }}
//             >
//               Profile
//             </button>
//             <button
//               className={serviceTab ? "profile_active" : "button"}
//               onClick={() => {
//                 setProfileTab(false);
//                 setServiceTab(true);
//                 setPaymentTab(false);
//               }}
//             >
//               Services
//             </button>
//             <button
//               className={paymentTab ? "profile_active" : "button"}
//               onClick={() => {
//                 setProfileTab(false);
//                 setServiceTab(false);
//                 setPaymentTab(true);
//               }}
//             >
//               Payment
//             </button>
//             {/* <button className={"button"} onClick={() => handleClick()}>
//               Submit Information
//             </button> */}
//             {/* {isFinallySubmittedForm  ? (
//               <button
//                 className={"button"}
//                 // onClick={() => navigate("/form-fill-up-step1-applicant-details")}
//               >
//                 Download Form PDF
//               </button>
//             ) : (
//               <button
//                 className={"button"}
//                 onClick={() =>
//                   navigate("/form-fill-up-step1-applicant-details")
//                 }
//               >
//                 Fill immigration Form
//               </button>
//             )} */}

//             {isFinallySubmittedForm && serviceData?.length > 0 && (
//               <button className="button">Download Form PDF</button>
//             )}
//             {!isFinallySubmittedForm && serviceData?.length > 0 && (
//               <button
//                 className={"button"}
//                 onClick={() =>
//                   navigate("/form-fill-up-step1-applicant-details")
//                 }
//               >
//                 Fill immigration Form
//               </button>
//             )}

//             <button className={"button"} onClick={(e) => handleLogout(e)}>
//               Logout
//             </button>
//           </div>
//           {profileTab && (
//             <div className="profile_fields_wrapper">
//               <div className="name_field" style={{ display: "flex" }}>
//                 {/* <i onClick={(() => setModal(true))} class="fa-regular fa-pen-to-square"></i> */}
//                 <label style={{ marginTop: "7px" }}>Name - </label>
//                 <input type="text" readOnly defaultValue={user?.name} />
//               </div>
//               <div className="name_field">
//                 {/* <i onClick={(()=>setModal(true))} class="fa-regular fa-pen-to-square"></i> */}
//                 <label>Email - </label>
//                 <input type="text" readOnly defaultValue={user?.email} />
//               </div>
//             </div>
//           )}

//           {serviceTab && (
//             <div className="service_accordion_Wrapper">
//               <ServiceAccordion />
//             </div>
//           )}
//           {paymentTab && (
//             <div className="service_accordion_Wrapper">
//               <PaymentHistory />
//             </div>
//           )}
//         </div>
//       </div>
//     </>
//   );
// };

// export default Profile;

import React, { useEffect, useState } from "react";
import Bannerslide from "../../Component/Home/Bannerslide";
import "./Profile.css";
import ServiceAccordion from "./ServiceAccordion";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { checkLogin, logout } from "../../Redux/Slice/authSlice";
import InnerBanner from "../../Component/InnerBanner";
import PaymentHistory from "./PaymentHistory";
import HomeServices from "../../Services/HomeServices";
import toast from "react-hot-toast";
import jsPDF from "jspdf";
import "jspdf-autotable";

const Profile = () => {
  const { loading, error, token, user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [profileTab, setProfileTab] = useState(true);
  const [serviceTab, setServiceTab] = useState(false);
  const [paymentTab, setPaymentTab] = useState(false);
  const [isFinallySubmittedForm, setIsFinallySubmittedForm] = useState(false);
  const [serviceData, setServiceData] = useState([]);
  const [applicantData, setApplicantData] = useState(null);

  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkLogin());
  }, [dispatch]);

  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    toast.success("Logged out Successfully");
    navigate("/");
  };

  const ProfileModal = () => {
    return (
      <>
        <div className="modal_wrapper_main_div"></div>
        <div className="modal_div_main">
          <h5>Edit Profile Info</h5>
          {user?.customerNo && (
            <div className="edit_input_Wrapper">
              <label>Customer# {user?.customerNo}</label>
            </div>
          )}

          <div className="edit_input_Wrapper">
            <label>Name</label>
            <input type="text" defaultValue={user?.name} />
          </div>

          <div className="edit_input_Wrapper mt-2">
            <label>Email</label>
            <input type="text" defaultValue={user?.email} />
          </div>
          <div className="submit_btn_wrapper">
            <button onClick={() => setModal(false)}>Submit</button>
          </div>
        </div>
      </>
    );
  };

  const fetchApplicantData = async () => {
    try {
      const res = await HomeServices.getPrimariApplicantData();
      console.log("user", res);
      if (res?.status && res?.data) {
        setApplicantData(res?.data[0]?.PrimaryApplicantData);
        setIsFinallySubmittedForm(
          res?.data[0]?.PrimaryApplicantData?.isFinallySubmittedForm,
        );
      } else {
        toast?.error("server Error!");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServicesData = async () => {
    try {
      const res = await HomeServices.getAllAssignedServices();
      console.log("DFFE12", res.data);
      if (res && res.status) {
        setServiceData(res.data);
      }
    } catch (error) {
      console.error("Error uploading document:", error);
    }
  };

  useEffect(() => {
    fetchServicesData();
    fetchApplicantData();
  }, []);

  // Format date to readable format
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return "N/A";
    }
  };

  // Format boolean/yes-no responses
  const formatResponse = (value) => {
    if (value === undefined || value === null || value === "") return "N/A";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    return value.toString();
  };

  const downloadPDF = () => {
    if (!applicantData) {
      toast.error("No applicant data available");
      return;
    }

    const doc = new jsPDF();
    const fullFormData = applicantData;

    // Title
    doc.setFontSize(20);
    doc.setTextColor(255, 156, 0); // #ff9c00
    doc.text("IMMIGRATION APPLICATION FORM", 105, 15, null, null, "center");

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    // doc.text(`Application ID: ${fullFormData?._id || "N/A"}`, 15, 25);
    doc.text(`Date: ${new Date().toLocaleDateString()}`, 180, 25);

    let yPos = 35;
    const leftMargin = 15;
    const rightMargin = 195;
    const pageHeight = 280;

    // Helper function to add text with word wrap
    const addTextWithWrap = (text, x, y, maxWidth) => {
      if (!text || text === "N/A") return 0;
      const lines = doc.splitTextToSize(text.toString(), maxWidth);
      doc.text(lines, x, y);
      return lines.length;
    };

    // Helper function to check page break
    const checkPageBreak = (requiredSpace = 10) => {
      if (yPos + requiredSpace > pageHeight) {
        doc.addPage();
        yPos = 20;
        return true;
      }
      return false;
    };

    // Helper function to add section
    const addSection = (title, contentLines) => {
      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(title, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      contentLines.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add array section
    const addArraySection = (title, items, itemTitle, fields) => {
      if (!items || items.length === 0) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${title} (${items.length})`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      items.forEach((item, index) => {
        checkPageBreak(20);

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`${itemTitle} ${index + 1}`, leftMargin, yPos);
        yPos += 8;

        doc.setDrawColor(200, 200, 200);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 10;

        doc.setFontSize(10);
        fields.forEach(({ label, key }) => {
          const value = item[key];
          if (!value) return;

          checkPageBreak(8);

          doc.setFont("helvetica", "bold");
          doc.text(`${label}:`, leftMargin + 10, yPos);

          doc.setFont("helvetica", "normal");
          const valueText = value?.toString() || "N/A";
          const lines = addTextWithWrap(
            valueText,
            leftMargin + 80,
            yPos,
            rightMargin - leftMargin - 80,
          );

          yPos += lines * 7 + 2;
        });

        yPos += 5;
      });
    };

    // Helper function to add language test section
    const addLanguageTestSection = (personData, personName) => {
      if (!personData || personData.languageTestTaken !== "Yes") return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} LANGUAGE TEST DETAILS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      const testFields = [
        { label: "Test Type", value: personData.typeOfTest },
        { label: "Test Version", value: personData.languageTestVersion },
        { label: "Date of Test", value: formatDate(personData.dateOfTest) },
        {
          label: "Date of Result",
          value: formatDate(personData.dateOfTestResult),
        },
        {
          label: "Certificate No",
          value: personData.languageTestCertificateNo,
        },
      ];

      if (personData.typeOfTest === "IELTS") {
        testFields.push({
          label: "IELTS Certificate No",
          value: personData.IELTScertificateNo,
        });
      } else if (personData.typeOfTest === "CELPIP") {
        testFields.push(
          { label: "CELPIP Reg No", value: personData.CELPIPregNo },
          { label: "CELPIP PIN No", value: personData.CELPIPpinNo },
        );
      } else if (personData.typeOfTest === "PTE") {
        testFields.push(
          { label: "PTE Report Code", value: personData.PTEreportCode },
          { label: "PTE Test Taker ID", value: personData.PTEtestTakerId },
          { label: "PTE Reg ID", value: personData.PTEregId },
        );
      }

      testFields.push(
        { label: "Speaking", value: personData.speaking },
        { label: "Reading", value: personData.reading },
        { label: "Listening", value: personData.listening },
        { label: "Writing", value: personData.writing },
        {
          label: "French Test Taken",
          value: personData.takenAnApprovedTestForFrench,
        },
      );

      testFields.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add ECA section
    const addECASection = (personData, personName) => {
      if (!personData || !personData.ECAOrganization) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} ECA DETAILS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      const ecaFields = [
        { label: "Organization", value: personData.ECAOrganization },
        {
          label: "Report Issue Date",
          value: formatDate(personData.dateECAreportIssued),
        },
        { label: "Certificate No", value: personData.ECAcertificateNo },
        { label: "Equivalency", value: personData.ECAequivalency },
      ];

      ecaFields.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add declarations for a person
    const addDeclarationsForPerson = (personData, personName) => {
      const declarations = [
        {
          question: "Has applicant been refused visa or permit?",
          answer:
            personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
          remarks:
            personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
        },
        {
          question: "Has applicant committed any criminal offence?",
          answer:
            personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
          remarks:
            personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
        },
        {
          question: "Has applicant been detained or incarcerated?",
          answer: personData?.HasApplicantBeenDetainedIncarceratedorPutinJail,
          remarks:
            personData?.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
        },
        {
          question: "Has applicant been associated with armed groups?",
          answer:
            personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
          remarks:
            personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
        },
        {
          question: "Has applicant been involved in war crimes?",
          answer:
            personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
          remarks:
            personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
        },
        {
          question: "Has applicant been member of criminal organization?",
          answer:
            personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
          remarks:
            personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
        },
        {
          question: "Has applicant had serious disease or disorder?",
          answer:
            personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,
          remarks:
            personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,
        },
        {
          question: "Has applicant used/planned armed struggle?",
          answer:
            personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectives,
          remarks:
            personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectivesRemarks,
        },
        {
          question: "Has applicant been convicted in Canada without pardon?",
          answer:
            personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
          remarks:
            personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
        },
      ];

      const hasDeclarations = declarations.some(
        (decl) => decl.answer || (decl.remarks && decl.remarks.trim() !== ""),
      );

      if (!hasDeclarations) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} DECLARATIONS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);

      declarations.forEach((decl) => {
        const answer = decl.answer;
        const remarks = decl.remarks;

        if (!answer && !(remarks && remarks.trim() !== "")) return;

        checkPageBreak(15);

        if (answer === "Yes") {
          doc.setTextColor(220, 53, 69);
        } else if (answer === "No") {
          doc.setTextColor(40, 167, 69);
        } else {
          doc.setTextColor(0, 0, 0);
        }

        doc.setFont("helvetica", "bold");
        const questionText = `• ${decl.question}: ${formatResponse(answer)}`;
        const questionLines = addTextWithWrap(
          questionText,
          leftMargin,
          yPos,
          rightMargin - leftMargin,
        );
        yPos += questionLines * 7;

        if (remarks && remarks.trim() !== "") {
          checkPageBreak(8);
          doc.setTextColor(100, 100, 100);
          doc.setFont("helvetica", "italic");
          const remarksText = `  Remarks: ${remarks}`;
          const remarksLines = addTextWithWrap(
            remarksText,
            leftMargin + 5,
            yPos,
            rightMargin - leftMargin - 5,
          );
          yPos += remarksLines * 6;
        }

        doc.setTextColor(0, 0, 0);
        yPos += 3;
      });

      yPos += 5;
    };

    // Start building PDF
    if (fullFormData) {
      // Primary Applicant Information
      const primaryInfo = [
        {
          label: "Name",
          value: `${fullFormData.firstName || ""} ${fullFormData.middleName || ""} ${fullFormData.lastName || ""}`,
        },
        { label: "Date of Birth", value: formatDate(fullFormData.dateOfBirth) },
        { label: "Gender", value: fullFormData.gender },
        { label: "Email", value: fullFormData.emailId },
        { label: "Telephone", value: fullFormData.telephoneNo },
        { label: "Passport No", value: fullFormData.passportNo },
        {
          label: "Country of Citizenship",
          value: fullFormData.countryOfCitizenship,
        },
        { label: "Country of Birth", value: fullFormData.countryOfBirth },
        { label: "City of Birth", value: fullFormData.cityOfBirth },
        { label: "Marital Status", value: fullFormData.maritalStatus },
        { label: "NOC Code", value: fullFormData.primaryOccupationOrNOCcode },
        { label: "EE Profile No", value: fullFormData.EEno },
        { label: "UCI No", value: fullFormData.UCIno },
        { label: "CSQ", value: fullFormData.CSQ },
        { label: "CSQ Remarks", value: fullFormData.CSQRemarks },
        { label: "UNHCR", value: fullFormData.UNHCR },
        { label: "UNHCR Remarks", value: fullFormData.UNHCRRemarks },
        { label: "Native Language", value: fullFormData.nativeLanguage },
        { label: "Other Name", value: fullFormData.otherName },
        { label: "Status in Canada", value: fullFormData.statusInCanada },
        {
          label: "Place Entered in Canada",
          value: fullFormData.placeOfEnteredInCanada,
        },
        {
          label: "First Time Entered",
          value: formatDate(fullFormData.firstTimeEnteredInCanada),
        },
        {
          label: "Last Time Entered",
          value: formatDate(fullFormData.lastTimeEnteredInCanada),
        },
      ];

      addSection("PRIMARY APPLICANT INFORMATION", primaryInfo);

      // Primary Applicant Education History
      if (
        fullFormData.educationHistory &&
        fullFormData.educationHistory.length > 0
      ) {
        addArraySection(
          "PRIMARY APPLICANT EDUCATION HISTORY",
          fullFormData.educationHistory,
          "Education",
          [
            { label: "Level of Education", key: "levelOfEducation" },
            { label: "Field of Study", key: "studyName" },
            { label: "From Date", key: "fromDate", format: formatDate },
            { label: "To Date", key: "toDate", format: formatDate },
            { label: "City of Education", key: "cityOfEducation" },
            { label: "Country of Education", key: "countryOfEducation" },
            { label: "Institution Name", key: "nameOfInstitution" },
            { label: "Institution Address", key: "addressOfInstitution" },
            { label: "DLI Number", key: "designatedLearningInstituteNo" },
            { label: "Campus City", key: "cityOfCampusAttended" },
          ],
        );
      }

      // Primary Applicant Language Test
      addLanguageTestSection(fullFormData, "PRIMARY APPLICANT");

      // Primary Applicant ECA
      addECASection(fullFormData, "PRIMARY APPLICANT");

      // Primary Applicant Work History
      if (fullFormData.workHistory && fullFormData.workHistory.length > 0) {
        addArraySection(
          "PRIMARY APPLICANT WORK HISTORY",
          fullFormData.workHistory,
          "Work Experience",
          [
            { label: "Job Title", key: "jobTitle" },
            { label: "From Date", key: "jobFromDate", format: formatDate },
            { label: "To Date", key: "jobToDate", format: formatDate },
            {
              label: "Employment Type",
              key: "fullTimeOrPartTime",
              format: (v) => (v === "full" ? "Full Time" : "Part Time"),
            },
            { label: "Hours/Week", key: "hoursPerWeek" },
            { label: "NOC Code", key: "NOCcode" },
            { label: "Company Name", key: "companyName" },
            { label: "Company Address", key: "companyAddressWithPostalCode" },
          ],
        );
      }

      // Primary Applicant Employment Status
      const employmentInfo = [
        {
          label: "Working Legally in Canada",
          value: fullFormData.workingLegallyInCanada,
        },
        {
          label: "Primary Occupation/NOC Code",
          value: fullFormData.primaryOccupationOrNOCcode,
        },
        {
          label: "Has Job Offer/LMIA",
          value: fullFormData.havingAnyJOBOFFERorLMIAInCanada,
        },
      ];

      addSection("PRIMARY APPLICANT EMPLOYMENT STATUS", employmentInfo);

      // Primary Applicant Relatives in Canada
      if (fullFormData.relativesInCanada === "Yes") {
        const relativesInfo = [
          {
            label: "Has Relatives in Canada",
            value: fullFormData.relativesInCanada,
          },
          {
            label: "Resident Status",
            value: fullFormData.relativesInCanadaResidentWith,
          },
        ];
        addSection("RELATIVES IN CANADA", relativesInfo);
      }

      // Primary Applicant Address Information
      const addressInfo = [
        { label: "Mailing Address", value: fullFormData.mailingAddress },
        { label: "Permanent Address", value: fullFormData.permanentAddress },
        {
          label: "City/Province of Residence",
          value: fullFormData.cityOrProvinceOfResidence,
        },
        {
          label: "Current Country of Residence",
          value: fullFormData.currentCountryOfResidence,
        },
        {
          label: "Province Considering Living",
          value: fullFormData.provinceOfConsiderLiving,
        },
        {
          label: "Money to Bring to Canada",
          value: fullFormData.moneyBroughtToCanada,
        },
        {
          label: "Total Family Members",
          value: fullFormData.totalFamilyMemberIncludingSpouseAndChild,
        },
        { label: "Spouse Count", value: fullFormData.spouseCount },
        { label: "Child Count", value: fullFormData.childCount },
        {
          label: "Applied to Express Entry Before",
          value: fullFormData.didAppliedToExpressEntryCanadaBefore,
        },
        {
          label: "Received Nomination Certificate",
          value:
            fullFormData.receivedNominationCertificateFromProvinceOrTerritory,
        },
        { label: "Relation", value: fullFormData.relation },
      ];

      addSection("ADDRESS & ADDITIONAL INFORMATION", addressInfo);

      // Primary Applicant Declarations
      addDeclarationsForPerson(fullFormData, "PRIMARY APPLICANT");

      // Spouse Information if exists
      if (fullFormData.PrimaryApplicantSpouseData) {
        const spouse = fullFormData.PrimaryApplicantSpouseData;

        const spouseInfo = [
          {
            label: "Name",
            value: `${spouse.firstName || ""} ${spouse.middleName || ""} ${spouse.lastName || ""}`,
          },
          { label: "Date of Birth", value: formatDate(spouse.dateOfBirth) },
          { label: "Gender", value: spouse.gender },
          { label: "Email", value: spouse.emailId },
          { label: "Telephone", value: spouse.telephoneNo },
          { label: "Passport No", value: spouse.passportNo },
          {
            label: "Country of Citizenship",
            value: spouse.countryOfCitizenship,
          },
          { label: "Country of Birth", value: spouse.countryOfBirth },
          { label: "City of Birth", value: spouse.cityOfBirth },
          {
            label: "Date of Marriage",
            value: formatDate(spouse.dateOfMarriage),
          },
          { label: "NOC Code", value: spouse.primaryOccupationOrNOCcode },
          { label: "EE Profile No", value: spouse.EEno },
          { label: "UCI No", value: spouse.UCIno },
          { label: "CSQ", value: spouse.CSQ },
          { label: "CSQ Remarks", value: spouse.CSQRemarks },
          { label: "UNHCR", value: spouse.UNHCR },
          { label: "UNHCR Remarks", value: spouse.UNHCRRemarks },
          { label: "Status in Canada", value: spouse.statusInCanada },
        ];

        addSection("SPOUSE INFORMATION", spouseInfo);

        // Spouse Education History
        if (spouse.educationHistory && spouse.educationHistory.length > 0) {
          addArraySection(
            "SPOUSE EDUCATION HISTORY",
            spouse.educationHistory,
            "Education",
            [
              { label: "Level of Education", key: "levelOfEducation" },
              { label: "Field of Study", key: "studyName" },
              { label: "From Date", key: "fromDate", format: formatDate },
              { label: "To Date", key: "toDate", format: formatDate },
              { label: "City of Education", key: "cityOfEducation" },
              { label: "Country of Education", key: "countryOfEducation" },
              { label: "Institution Name", key: "nameOfInstitution" },
              { label: "Institution Address", key: "addressOfInstitution" },
              { label: "DLI Number", key: "designatedLearningInstituteNo" },
              { label: "Campus City", key: "cityOfCampusAttended" },
            ],
          );
        }

        // Spouse Language Test
        addLanguageTestSection(spouse, "SPOUSE");

        // Spouse ECA
        addECASection(spouse, "SPOUSE");

        // Spouse Work History
        if (spouse.workHistory && spouse.workHistory.length > 0) {
          addArraySection(
            "SPOUSE WORK HISTORY",
            spouse.workHistory,
            "Work Experience",
            [
              { label: "Job Title", key: "jobTitle" },
              { label: "From Date", key: "jobFromDate", format: formatDate },
              { label: "To Date", key: "jobToDate", format: formatDate },
              {
                label: "Employment Type",
                key: "fullTimeOrPartTime",
                format: (v) => (v === "full" ? "Full Time" : "Part Time"),
              },
              { label: "Hours/Week", key: "hoursPerWeek" },
              { label: "NOC Code", key: "NOCcode" },
              { label: "Company Name", key: "companyName" },
              { label: "Company Address", key: "companyAddressWithPostalCode" },
            ],
          );
        }

        // Spouse Employment Status
        const spouseEmploymentInfo = [
          {
            label: "Working Legally in Canada",
            value: spouse.workingLegallyInCanada,
          },
          {
            label: "Primary Occupation/NOC Code",
            value: spouse.primaryOccupationOrNOCcode,
          },
          {
            label: "Has Job Offer/LMIA",
            value: spouse.havingAnyJOBOFFERorLMIAInCanada,
          },
        ];

        addSection("SPOUSE EMPLOYMENT STATUS", spouseEmploymentInfo);

        // Spouse Declarations
        addDeclarationsForPerson(spouse, "SPOUSE");
      }

      // Children Information if exists
      if (
        fullFormData.PrimaryApplicantChildData &&
        fullFormData.PrimaryApplicantChildData.length > 0
      ) {
        fullFormData.PrimaryApplicantChildData.forEach((child, index) => {
          const childInfo = [
            {
              label: "Name",
              value: `${child.firstName || ""} ${child.middleName || ""} ${child.lastName || ""}`,
            },
            { label: "Date of Birth", value: formatDate(child.dateOfBirth) },
            { label: "Gender", value: child.gender },
            { label: "Email", value: child.emailId },
            { label: "Telephone", value: child.telephoneNo },
            { label: "Passport No", value: child.passportNo },
            {
              label: "Country of Citizenship",
              value: child.countryOfCitizenship,
            },
            { label: "Country of Birth", value: child.countryOfBirth },
            { label: "City of Birth", value: child.cityOfBirth },
            { label: "CSQ", value: child.CSQ },
            { label: "CSQ Remarks", value: child.CSQRemarks },
            { label: "UNHCR", value: child.UNHCR },
            { label: "UNHCR Remarks", value: child.UNHCRRemarks },
            { label: "EE Profile No", value: child.EEno },
            { label: "UCI No", value: child.UCIno },
            { label: "Relation", value: child.relation },
          ];

          addSection(`CHILD ${index + 1} INFORMATION`, childInfo);
          addDeclarationsForPerson(child, `CHILD ${index + 1}`);
        });
      }

      // Submission Information
      const submissionInfo = [
        { label: "Created At", value: formatDate(fullFormData.createdAt) },
        { label: "User ID", value: fullFormData.userId },
        {
          label: "Status",
          value: fullFormData.isFinallySubmittedForm ? "Submitted" : "Draft",
        },
      ];

      addSection("SUBMISSION INFORMATION", submissionInfo);
    }

    // Footer
    checkPageBreak(20);
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(
      "Generated by Immigration Application System",
      105,
      yPos,
      null,
      null,
      "center",
    );
    doc.text(
      `Generated on: ${new Date().toLocaleString()}`,
      105,
      yPos + 5,
      null,
      null,
      "center",
    );

    // Save PDF
    doc.save(`Immigration-Application-${fullFormData?._id || "form"}.pdf`);
    toast.success("PDF downloaded successfully!");
  };

  return (
    <>
      {modal && <ProfileModal />}

      <InnerBanner InBanHead="My Profile" InBanLi="Profile" />

      <div className="profile_Wrapper">
        <div
          className="profile_sidebar_content_wrapper"
          style={{
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <div className="profile_tabs_wrapper">
            <button
              className={profileTab ? "profile_active" : "button"}
              onClick={() => {
                setProfileTab(true);
                setServiceTab(false);
                setPaymentTab(false);
              }}
            >
              Profile
            </button>
            <button
              className={serviceTab ? "profile_active" : "button"}
              onClick={() => {
                setProfileTab(false);
                setServiceTab(true);
                setPaymentTab(false);
              }}
            >
              Services
            </button>
            <button
              className={paymentTab ? "profile_active" : "button"}
              onClick={() => {
                setProfileTab(false);
                setServiceTab(false);
                setPaymentTab(true);
              }}
            >
              Payment
            </button>

            {isFinallySubmittedForm && serviceData?.length > 0 && (
              <button className="button" onClick={downloadPDF}>
                Download Form PDF
              </button>
            )}
            {!isFinallySubmittedForm && serviceData?.length > 0 && (
              <button
                className={"button"}
                onClick={() =>
                  navigate("/form-fill-up-step1-applicant-details")
                }
              >
                Fill immigration Form
              </button>
            )}

            <button className={"button"} onClick={(e) => handleLogout(e)}>
              Logout
            </button>
          </div>

          {profileTab && (
            <div className="profile_fields_wrapper">
              <div className="name_field" style={{ display: "flex" }}>
                <label style={{ marginTop: "7px" }}>Name - </label>
                <input type="text" readOnly defaultValue={user?.name} />
              </div>
              <div className="name_field">
                <label>Email - </label>
                <input type="text" readOnly defaultValue={user?.email} />
              </div>
            </div>
          )}

          {serviceTab && (
            <div className="service_accordion_Wrapper">
              <ServiceAccordion />
            </div>
          )}

          {paymentTab && (
            <div className="service_accordion_Wrapper">
              <PaymentHistory />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Profile;
